import Vue from 'vue'
import Router from 'vue-router'
import home from '../components/page/home/home'
import mine from '../components/page/mine/mine'
import cart from '../components/page/cart/cart'
import classify from '../components/page/home/classify'
import productList from '../components/page/home/productList'
import goodsDetail from '../components/page/goods/goodsDetail'
import orderList from '../components/page/mine/orderList'
import orderDetail from '../components/page/mine/orderDetail'
import collectBills from '../components/page/cart/collectBills'
import giveawayList from '../components/page/cart/giveawayList'
import orderEvaluation from '../components/page/mine/orderEvaluation'
import orderLogistics from '../components/page/mine/orderLogistics'
import orderComfirm from '../components/page/order/orderComfirm'
import addressList from '../components/page/order/addressList'
import address_add from '../components/page/order/address_add'
import distributionMenu from '../components/page/mine/distributionMenu'
import distributionRule from '../components/page/mine/distributionRule'
import promoList from '../components/page/promo/promoList'
import promoCenter from '../components/page/promo/promoCenter'
import goodsEvaluation from '../components/page/goods/goodsEvaluation'
import distributionInvite from '../components/page/mine/distributionInvite'
import distributionWithdraw from '../components/page/mine/distributionWithdraw'
import distributionIncome from '../components/page/mine/distributionIncome'
import distributionApply from '../components/page/mine/distributionApply'
import ticketInfo from '../components/page/ticket/ticketInfo'
import ticketComfirm from '../components/page/ticket/ticketComfirm'
import parkInfo from '../components/page/ticket/parkInfo'
import parkImgList from '../components/page/ticket/parkImgList'
import storeMap from '../components/page/ticket/storeMap'
import mineCollection from '../components/page/mine/mineCollection'
import afterList from '../components/page/after/afterList'
import afterStatus from '../components/page/after/afterStatus'
import afterType from '../components/page/after/afterType'
import afterCommit from '../components/page/after/afterCommit'
import afterLogistics from '../components/page/after/afterLogistics'
import orderDetailTicket from '../components/page/mine/orderDetailTicket'
import foodHome from '../components/page/tastyFoods/foodHome'
import activityList from '../components/page/activity/activityList'
import hotelInfo from '../components/page/hotel/hotelInfo'
import hotelDetail from '../components/page/hotel/hotelDetail'
import hotelComfirm from '../components/page/hotel/hotelComfirm'
import hotelDec from '../components/page/hotel/hotelDec'
import orderDetailHotel from '../components/page/mine/orderDetailHotel'
import cardBind from '../components/page/cardCurrency/cardBind'
import buyCard from '../components/page/cardCurrency/buyCard'
import physicalCardList from '../components/page/cardCurrency/physicalCardList'
import physicalCardDetail from '../components/page/cardCurrency/physicalCardDetail'
import cardComfirm from '../components/page/cardCurrency/cardComfirm'
import orderDetailGift from '../components/page/mine/orderDetailGift'
import orderDetailExchange from '../components/page/mine/orderDetailExchange'

import gameList from '../components/page/game/gameList'
import gameTurntable from '../components/page/game/gameTurntable'
import shareBill from '../components/page/share/shareBill'
import home1 from '../components/page/home/home1'
import home11 from '../components/page/home/home11'
import home2 from '../components/page/home/home2'
import home22 from '../components/page/home/home22'

import classList from '../components/page/mengwa/classList'
import classItemInfo from '../components/page/mengwa/classItemInfo'

import distributionExchange from "../components/page/mine/distributionExchange"
import gamePrize from "../components/page/game/gamePrize"
import exchangeDetail from '../components/page/goods/exchangeDetail'
import exchangeComfirm from '../components/page/mine/exchangeComfirm'

import emptyView from '../components/page/home/emptyView'

import {storeName} from "./Constant";


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: getVueDefaultRouterName(),
      component: getVueDefaultRouterComponent(),
      meta: {
        title: getVueDefaultRouterTitle()
      }
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        title: 'HelloKitty乐园官方商城'
      }
    },
    {
      path: '/home1',
      name: 'home1',
      component: home1,
      meta: {
        title: 'HelloKitty乐园官方商城'
      }
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine,
      meta: {
        title: '我的'
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: cart,
      meta: {
        title: '购物车'
      }
    },
    {
      path: '/classify',
      name: 'classify',
      component: classify,
      meta: {
        title: '全部分类'
      }
    },
    {
      path: '/productList',
      name: 'productList',
      component: productList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: goodsDetail,
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/collectBills',
      name: 'collectBills',
      component: collectBills,
    },
    {
      path: '/giveawayList',
      name: 'giveawayList',
      component: giveawayList,
    },
    {
      path: '/orderEvaluation',
      name: 'orderEvaluation',
      component: orderEvaluation,
      meta: {
        title: '评价晒单'
      }
    },
    {
      path: '/orderLogistics',
      name: 'orderLogistics',
      component: orderLogistics,
      meta: {
        title: '物流详情'
      }
    },
    {
      path: '/orderComfirm',
      name: 'orderComfirm',
      component: orderComfirm,
      meta: {
        title: '订单确认'
      }
    },
    {
      path: '/addressList',
      name: 'addressList',
      component: addressList,
      meta: {
        title: '我的地址'
      }
    },
    {
      path: '/address_add',
      name: 'address_add',
      component: address_add,
      meta: {
        title: '添加地址'
      }
    },
    {
      path: '/distributionMenu',
      name: 'distributionMenu',
      component: distributionMenu,
      meta: {
        title: '我的收益'
      }
    },
    {
      path: '/distributionRule',
      name: 'distributionRule',
      component: distributionRule,
      meta: {
        title: '分享赚收益规则'
      }
    },
    {
      path: '/promoList',
      name: 'promoList',
      component: promoList,
      meta: {
        title: '我的优惠券'
      }
    },
    {
      path: '/promoCenter',
      name: 'promoCenter',
      component: promoCenter,
      meta: {
        title: '领券中心'
      }
    },
    {
      path: '/goodsEvaluation',
      name: 'goodsEvaluation',
      component: goodsEvaluation,
      meta: {
        title: '商品评价'
      }
    },
    {
      path: '/distributionInvite',
      name: 'distributionInvite',
      component: distributionInvite,
      meta: {
        title: '收益邀请'
      }
    },
    {
      path: '/distributionWithdraw',
      name: 'distributionWithdraw',
      component: distributionWithdraw,
      meta: {
        title: '提现记录'
      }
    },
    {
      path: '/distributionIncome',
      name: 'distributionIncome',
      component: distributionIncome,
      meta: {
        title: '收益明细'
      }
    },
    {
      path: '/distributionApply',
      name: 'distributionApply',
      component: distributionApply,
      meta: {
        title: '申请提现'
      }
    },
    //门票
    {
      path: '/ticketInfo',
      name: 'ticketInfo',
      component: ticketInfo,
      meta: {
        title: '门票预定'
      }
    },
    {
      path: '/ticketComfirm',
      name: 'ticketComfirm',
      component: ticketComfirm,
    },
    {
      path: '/parkInfo',
      name: 'parkInfo',
      component: parkInfo,
    },
    {
      path: '/parkImgList',
      name: 'parkImgList',
      component: parkImgList,
    },
    {
      path: '/storeMap',
      name: 'storeMap',
      component: storeMap,
    },
    {
      path: '/mineCollection',
      name: 'mineCollection',
      component: mineCollection,
      meta: {
        title: '我的收藏'
      }
    },
    {
      path: '/afterList',
      name: 'afterList',
      component: afterList,
      meta: {
        title: '退换/售后'
      }
    },
    {
      path: '/afterStatus',
      name: 'afterStatus',
      component: afterStatus,
      meta: {
        title: '售后进度'
      }
    },
    {
      path: '/afterType',
      name: 'afterType',
      component: afterType,
      meta: {
        title: '选择售后类型'
      }
    },
    {
      path: '/afterLogistics',
      name: 'afterLogistics',
      component: afterLogistics,
      meta: {
        title: '售后进度'
      }
    },
    {
      path: '/afterCommit',
      name: 'afterCommit',
      component: afterCommit,
      meta: {
        title: '售后申请'
      }
    },
    {
      path: '/orderDetailTicket',
      name: 'orderDetailTicket',
      component: orderDetailTicket,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/foodHome',
      name: 'foodHome',
      component: foodHome,
      meta: {
        title: '自营线上餐饮美食'
      }
    },
    {
      path: '/activityList',
      name: 'activityList',
      component: activityList,
      meta: {
        title: '女神节专属礼遇'
      }
    },
    {
      path: '/hotelInfo',
      name: 'hotelInfo',
      component: hotelInfo,
      meta: {
        title: '畅“住”HelloKittyPark'
      }
    },
    {
      path: '/hotelDetail',
      name: 'hotelDetail',
      component: hotelDetail,
      meta: {
        title: '房间详情'
      }
    },
    {
      path: '/hotelComfirm',
      name: 'hotelComfirm',
      component: hotelComfirm,
      meta: {
        title: '畅“住”HelloKittyPark'
      }
    },
    {
      path: '/hotelDec',
      name: 'hotelDec',
      component: hotelDec,
      meta: {
        title: '详情与设施'
      }
    },
    {
      path: '/orderDetailHotel',
      name: 'orderDetailHotel',
      component: orderDetailHotel,
      meta: {
        title: '酒店订单详情'
      }
    },
    {
      path: '/classList',
      name: 'classList',
      component: classList,
      meta: {
        title: 'Hello Kitty课堂'
      }
    },
    {
      path: '/classItemInfo',
      name: 'classItemInfo',
      component: classItemInfo,
      meta: {
        title: 'Hello Kitty课堂'
      }
    },
    {
      path: '/gameList',
      name: 'gameList',
      component: gameList,
      meta: {
        title: '大转盘'
      }
    },
    {
      path: '/gameTurntable',
      name: 'gameTurntable',
      component: gameTurntable,
      meta: {
        title: '大转盘'
      }
    },
    {
      path: '/shareBill',
      name: 'shareBill',
      component: shareBill,
      meta: {
        title: '分享海报'
      }
    },
    {
      path: '/cardBind',
      name: 'cardBind',
      component: cardBind,
      meta: {
        title: '绑定卡币'
      }
    },
    {
      path: '/buyCard',
      name: 'buyCard',
      component: buyCard,
      meta: {
        title: '购买卡币数字卡'
      }
    },
    {
      path: '/distributionExchange',
      name: 'distributionExchange',
      component: distributionExchange,
      meta: {
        title: '兑换专区'
      }
    },

    {
      path: '/physicalCardList',
      name: 'physicalCardList',
      component: physicalCardList,
      meta: {
        title: '购买礼品卡'
      }
    },
    {
      path: '/physicalCardDetail',
      name: 'physicalCardDetail',
      component: physicalCardDetail,
      meta: {
        title: '礼品卡详情'
      }
    },
    {
      path: '/cardComfirm',
      name: 'cardComfirm',
      component: cardComfirm,
      meta: {
        title: '订单提交'
      }
    },
    {
      path: '/orderDetailGift',
      name: 'orderDetailGift',
      component: orderDetailGift,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/orderDetailExchange',
      name: 'orderDetailExchange',
      component: orderDetailExchange,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/gamePrize',
      name: 'gamePrize',
      component: gamePrize,
      meta: {
        title: '我的奖品'
      }
    },
    {
      path: '/exchangeDetail',
      name: 'exchangeDetail',
      component: exchangeDetail,
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/exchangeComfirm',
      name: 'exchangeComfirm',
      component: exchangeComfirm,
      meta: {
        title: '订单提交'
      }
    },
    {
      path: '/emptyView',
      name: 'emptyView',
      component: emptyView,
      meta: {
        title: '暂未开放'
      }
    },
  ]
})


const routerPush = Router.prototype.push
const routerReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error=> error)
}


function getVueDefaultRouterName() {
  var name = ""
  if (storeName == "OnlineStore") {
    name = home
  }  else if (storeName == 'Tickets') {
    name = ticketInfo
  } else if (storeName == 'Hotel') {
    name = hotelInfo
  } else if (storeName == 'KCoinStore') {
    name = distributionExchange
  }else if (storeName == 'GiftCardStore'){
    name = physicalCardList
  }
  return name
}

function getVueDefaultRouterComponent() {
  var component = ""
  if (storeName == "OnlineStore") {
    component = home
  } else if (storeName == 'Tickets') {
    component = ticketInfo
  } else if (storeName == 'Hotel') {
    component = hotelInfo
  }  else if (storeName == 'KCoinStore') {
    component = distributionExchange
  }else if (storeName == 'GiftCardStore'){
    component = physicalCardList
  }
  return component
}

function getVueDefaultRouterTitle() {
  var title = ""
  if (storeName == "OnlineStore") {
    title = "HelloKitty乐园官方商城"
  } else if (storeName == 'Tickets') {
    title = "门票预定"
  } else if (storeName == 'Hotel') {
    title = "畅“住”HelloKittyPark"
  }  else if (storeName == 'KCoinStore') {
    title = "兑换专区"
  }else if (storeName == 'GiftCardStore'){
    title = '礼品卡购买'
  }
  return title
}





// WEBPACK FOOTER //
// ./src/router/index.js